<angular-template tag="div">
    <vrm-dropdown id="{{dropdownTrigger}}" close-on="mouseleave">
        <div class="vrm-dropdown__item" ng-repeat="item in items" ng-click="item.action()">
            <span ng-class="item.icon_class"></span>
            <a>{{item.text}}</a>
        </div>
    </vrm-dropdown>
</angular-template>
<style scoped lang="scss"></style>
<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import $ from 'jquery';

@Component()
export default class VrmDropdownPopup extends Vue {
    @Prop({
        type: Array,
        default: () => [],
        validator(list) {
            return list.every(({ icon_class, text, action }) => {
                return _.isFunction(action) && _.isString(text) && _.isString(icon_class);
            });
        },
    })
    items; // List of dropdown items
    @Prop()
    dropdownTrigger;

    beforeDestroy() {
        $('.vrm-dropdown.tether-element').each(function() {
            // "On destroy" is not properly called for the angular component. Remove any tethers left behind
            $(this).remove();
        });
    }
}
</script>
